// extracted by mini-css-extract-plugin
export default {"return":"howMuchPaidDrawer_return__jpfyn","confirm":"howMuchPaidDrawer_confirm__fR-Pz"};